const userRolePriority = {
  BarTrack: 1,
  Owner: 2,
  Manager: 3,
  Bartender: 4,
  'Line Maintenance': 5,
};

export default userRolePriority;
